import { AgentItemsListState } from "app/pages/AgentSearch/modules/AgentItemsList/state";

function getRoot(state: any) : AgentItemsListState {
    return state.agentItemsList;
}

export function getAgents(state: any) {
    const root = getRoot(state);
    return root.agents;
}

export function getSearchTerm(state: any) {
    const root = getRoot(state);
    return root.searchTerm;
}

export function getSearchStatus(state: any) {
    const root = getRoot(state);
    return root.searchStatus;
}